import React from 'react';
import styled, {css} from 'styled-components';
import themeResponsiveProperty from "../responsive/themeResponsiveProperty";

const TitleLabel = styled.span`
  font-size: 1rem;
  font-weight: ${themeResponsiveProperty('bold', null)};
  text-transform: uppercase;

  ${props => props.theme.isTablet && css`
    font-size: 1.125rem;
  `};
`;

const ItemLabel = styled(TitleLabel)`
  font-weight: normal;
  text-transform: capitalize;

  ${props => props.theme.isTablet && css`
    font-size: 1.125rem;
  `};
`;

const TitleSmallLabel = styled(TitleLabel)`
  font-size: ${themeResponsiveProperty(null, '1.125rem')};
`;

const ItemSmallLabel = styled(ItemLabel)`
  font-size: .8125rem;
`;

export {
  TitleLabel,
  ItemLabel,
  TitleSmallLabel,
  ItemSmallLabel,
};
